module.exports = __webpack_public_path__ + "img/286.235415be.jpg";